export default __webpack_public_path__ + "static/juniordesignerheader-840eb5b99b346efe6ffb72cb0fdde200.png";